"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchComponent = void 0;
class SearchComponent {
    setLobSpecificData() {
        this.lob = this.getParameterByName('lob');
        /* Commented this out because SonarQube complained about the unused variables */
        // let cmsUrl: any;
        // let supportLinkHtml: any;
        // let title = 'Need Some Help?';
        // if (this.lob === 'WebFTTHSupport') {
        //     title = 'Need help with your C Spire TV, Internet or Home Phone?';
        //     cmsUrl = '/cms/home-services/support/search-result/';
        // eslint-disable-next-line max-len
        //     supportLinkHtml = '<a href="/cms/wireless/support-home/">Support Home</a>|<a href="//help.cspire.com/app/home/p/1">Wireless Support</a>|<a href="//help.cspire.com/app/home/p/3">Business Solutions Support</a>';
        // } else if (this.lob === 'WebAFBSupport') {
        //     title = 'Need help with your C Spire Business Service?';
        //     cmsUrl = '/cms/business/search-result/';
        // eslint-disable-next-line max-len
        //     supportLinkHtml = '<a href="/cms/business/support-home/">Support Home</a>|<a href="//help.cspire.com/app/home/p/1">Wireless Support</a>|<a href="//help.cspire.com/app/home/p/2">Home Services Support</a>';
        // } else {
        //     title = 'Need help with your C Spire Wireless Service?';
        //     cmsUrl = '/cms/wireless/search-result/';
        // eslint-disable-next-line max-len
        //     supportLinkHtml = '<a href="/cms/wireless/support-home/">Support Home</a>|<a href="//help.cspire.com/app/home/p/2">Home Services Support</a>|<a href="//help.cspire.com/app/home/p/3">Business Solutions Support</a>';
        // }
        // document.querySelector('#wysdom-search-wrapper .wysdom-search-title').innerHTML = title;
        // document.querySelector('#wysdom-search-wrapper .support-links').innerHTML = supportLinkHtml;
    }
    getParameterByName(name) {
        const url = window.location.href;
        const fname = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + fname + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    initializeWysdomSearch() {
        setTimeout(function () {
            console.log(this);
            if (document.querySelectorAll('#wysdom-search-bar input').length && document.querySelectorAll('#wysdom-search-bar button').length) {
                const event = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                document.querySelector('#wysdom-search-bar button').dispatchEvent(event);
            }
        }, 500);
    }
}
exports.SearchComponent = SearchComponent;
//# sourceMappingURL=search.component.js.map